/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { HtmlAttr } from '../constants/enums'
import { Nullable } from '../constants/types'

export const StylesUtils = {
    /**
     * Manipulates element styles (preserves existing).
     */
    style(
        nodes: Nullable<HTMLElement | HTMLElement[]>,
        key: string,
        value?: string
    ): void {
        let elements: HTMLElement[]

        if (!nodes) {
            elements = []
        } else if (nodes instanceof HTMLElement) {
            elements = [nodes]
        } else {
            elements = nodes
        }

        elements.forEach((el: HTMLElement) => {
            const styles = this.getStylesObj(el)
            if (!value) {
                delete styles[key]
            } else {
                styles[key] = value
            }
            this.setStylesObj(el, styles)
        })
    },

    /**
     * Gets all styles from element and creates an object with property as keys
     * @param el
     */
    getStylesObj(el: Nullable<HTMLElement>): { [_: string]: string } {
        if (!el) {
            return {}
        }

        const styles: { [_: string]: string } = {}
        // get existing styles by key
        const styleAttr = el.getAttribute(HtmlAttr.STYLE)
        if (styleAttr) {
            styleAttr
                .split(';')
                .map((kv) => kv.split(':').map((_) => _.trim()))
                .forEach(([k, v]) => k && v && (styles[k] = v))
        }
        return styles
    },

    /**
     * Set element style attr from object of parameters
     * @param el
     * @param styles
     */
    setStylesObj(
        el: Nullable<HTMLElement>,
        styles: Record<string, string>
    ): void {
        if (!el) {
            return
        }
        el.setAttribute(
            HtmlAttr.STYLE,
            Object.entries(styles)
                .map(([k, v]) => `${k}:${v}`)
                .join(';')
        )
    }
}
